import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useUser } from "../API/Context/UserContext";
import { FRONTEND_ROUTES } from "../ConfigFiles/Routes/frontend_routes";
import { useDashboardPreference } from "../API/Context/AppUIContext";
import { UserRole } from "../Types/User/UserRoles";

const OnboardingGuard: React.FC = () => {
    const { 
        user, 
        isLoading, 
        hasRole, 
        isProfessional, 
        isMedicIntent, 
        isPatientProfileComplete, 
        isMedicProfileComplete 
    } = useUser();

    const { isProDashboardActive } = useDashboardPreference();

    if (isLoading) {
        return <div className="p-5 text-center">Verifying session...</div>;
    }

    if (!user) {
        return <Navigate to={FRONTEND_ROUTES.login} replace />;
    }

    //  PROFESSIONAL INTENT & PRO DASHBOARD
    //  If the user intends to be a medic OR has the pro dashboard active, run Pro checks first.
    console.log('isMedicIntent', isMedicIntent, 'isProDashboardActive', isProDashboardActive)
    console.log('isProDashboardActive', isProDashboardActive)
    console.log('isProfessional', isProfessional)
    if (isMedicIntent || isProDashboardActive) {
        // Step 1: Doctor without medic intent trying to access Pro side
        if (!isMedicIntent) {
            return <Navigate to={FRONTEND_ROUTES.patient_to_pro} replace />;
        }

        // Step 2: Unfinished onboarding profile
        if (hasRole(UserRole.PENDINGPROFESSIONAL) || !isMedicProfileComplete) {
            return <Navigate to={FRONTEND_ROUTES.pro_onboarding} replace />;
        }
        
        // Step 3: Finished profile, awaiting admin approval
        if (hasRole(UserRole.VERIFYINGPROFESSIONAL) || !isProfessional) {
            return <Navigate to={FRONTEND_ROUTES.pro_verification_pending} replace />;
        }

        // Step 4: Fully verified professional -> Allow access
        return <Outlet />;
    }

    //  PATIENT FLOW (When isProDashboardActive is false AND isMedicIntent is false)
    if (!isProDashboardActive) {
        //  Check if an existing verified pro is switching to patient side without a patient profile
        if (isProfessional && !hasRole(UserRole.BASE)) {
            return <Navigate to={FRONTEND_ROUTES.pro_to_patient} replace />;
        }
        
        // Regular Patient Onboarding check
        const needsPatientOnboarding = 
            hasRole(UserRole.PENDINGPATIENT) || 
            !isPatientProfileComplete;

        if (needsPatientOnboarding) {
            return <Navigate to={FRONTEND_ROUTES.profile_onboarding} replace />;
        }

        return <Outlet />;
    }

    return <Outlet />;
};

export default OnboardingGuard;